import { CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { createContext, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import AllRoutes from "./Routes";
import { DESKTOP_THEME, MOBILE_THEME } from "./utils/themeConstants";
import WrapperSnackBar from "./WrapperSnackBar";

export const ColorModeContext = createContext({ toggleColorMode: () => {} });

export const modeContext = createContext("");

const App = () => {
  const [mode, setMode] = useState("light");
  const { pathname } = useLocation();
  const hideHeader = pathname === "/login" || pathname === "/register";

  const colorMode = useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
      },
    }),
    []
  );

  const modeMode = useMemo(() => mode, [mode]);

  const themeDarkLight = useMemo(
    () =>
      createTheme({
        palette: {
          mode,
        },
      }),
    [mode]
  );
  const isMobile = useMediaQuery("(max-width:768px)");

  const themeInUse = isMobile ? MOBILE_THEME : DESKTOP_THEME;

  return (
    <ColorModeContext.Provider value={colorMode}>
      <modeContext.Provider value={modeMode}>
        <WrapperSnackBar colorMode={mode}>
          <ThemeProvider theme={themeDarkLight}>
            {!hideHeader && <Header />}
            <ThemeProvider
              theme={(theme) =>
                createTheme({
                  ...theme,
                  ...themeInUse,
                })
              }
            >
              <CssBaseline />
              <AllRoutes />
            </ThemeProvider>
          </ThemeProvider>
        </WrapperSnackBar>
      </modeContext.Provider>
    </ColorModeContext.Provider>
  );
};

export default App;
